var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcTabs = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.8333333,15.5833333 L3.66666667,15.5833333 L3.66666667,17.4166667 L12.8333333,17.4166667 L12.8333333,15.5833333 L12.8333333,15.5833333 Z M18.3333333,8.25 L3.66666667,8.25 L3.66666667,10.0833333 L18.3333333,10.0833333 L18.3333333,8.25 L18.3333333,8.25 Z M3.66666667,13.75 L18.3333333,13.75 L18.3333333,11.9166667 L3.66666667,11.9166667 L3.66666667,13.75 L3.66666667,13.75 Z M3.66666667,4.58333333 L3.66666667,6.41666667 L18.3333333,6.41666667 L18.3333333,4.58333333 L3.66666667,4.58333333 L3.66666667,4.58333333 Z",
    id: "eqwkewlqkeqlwk2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "eqwkewlqkeqlwk",
    x: 0,
    y: 0,
    width: 45.8333333,
    height: 45.8333333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "euwqoieuqwoi",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cxzczxcz",
    transform: "translate(-594.000000, -208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "adsadas",
    transform: "translate(268.000000, 174.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uluiououoi",
    transform: "translate(30.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_tabs",
    transform: "translate(293.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "eoiqweuqwi",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eqwkewlqkeqlwk2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "dqweqweqw"
  }), /*#__PURE__*/React.createElement("g", {
    id: "dsadsadas",
    mask: "url(#eoiqweuqwi)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.916667, -11.916667)",
    id: "\\uD83C\\uDFA8-Color"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eqwkewlqkeqlwk"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Black2",
    fill: "#BEC4CA",
    xlinkHref: "#eqwkewlqkeqlwk"
  }))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcTabs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic_tabs.500bba0f.svg";
export { ForwardRef as ReactComponent };